import * as React from 'react';

import {Button} from 'shells/button/button';

import {CreatePageModalRoot} from './create-page-modal-root';

type Props = {
    isLarge?: boolean;
    /** If true, the create page modal opens automatically on mount */
    initialOpen?: boolean;
};

export function CreatePageButton(props: Props) {
    const [isCreatingPage, setIsCreatingPage] = React.useState<boolean>(Boolean(props.initialOpen));

    return (
        <>
            <Button
                size={props.isLarge ? 'xlarge' : 'big'}
                variant='primary'
                onClick={() => {
                    setIsCreatingPage(true);
                }}
            >
                Create new page
            </Button>
            {isCreatingPage && (
                <CreatePageModalRoot
                    onClose={() => {
                        setIsCreatingPage(false);
                    }}
                />
            )}
        </>
    );
}
